export default __webpack_public_path__ + "static/media/吳廸融.b391bb6d.jpg";